import { Container, IconButton, Skeleton } from '@mui/material'
import styled from 'styled-components'

interface StyledContentProps {
  $hideHeader: boolean
}

interface ContentIconButtonCollapseProps {
  $isMinimized: boolean
}

// Styles do app.tsx
export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`

export const StyledContainer = styled(Container)`
  && {
    position: relative;
    display: flex;
    flex: 1;

    @media (min-width: 1440px) {
      max-width: 1400px;
    }

    @media (max-width: 900px) {
      flex-direction: column;
    }
  }
`

export const Main = styled.main`
  flex: 1;
`

// Styles do conteudo de cada rota
export const Content = styled.div<StyledContentProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 22px;
  padding: 20px 16px;
  overflow: auto;
  height: ${(props) =>
    props.$hideHeader ? 'calc(100vh - 40px)' : 'calc(100vh - 140px)'};
  overflow: auto;
  transition: height 0.3s ease;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.graySemiDark};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.gray};
    border-radius: 10px;
    border: 2px solid ${(props) => props.theme.colors.graySemiDark};
  }

  scrollbar-width: thin;
  scrollbar-color: ${(props) => props.theme.colors.gray}
    ${(props) => props.theme.colors.graySemiDark};

  @media (max-width: 1250px) {
    padding: 24px 24px 42px 0;
    height: ${(props) =>
      props.$hideHeader ? 'calc(100vh - 106px)' : 'calc(100vh - 224px)'};
  }

  @media (max-width: 900px) {
    padding: 24px 0;
    height: calc(100% - 48px);
  }
`

export const ContentTitle = styled.span`
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: ${(props) => props.theme.colors.white};
  font-size: 36px;
  font-weight: 700;
`

export const ContentIconButtonCollapse = styled(
  IconButton
)<ContentIconButtonCollapseProps>`
  && {
    width: 34px;
    height: 34px;
    color: ${(props) => props.theme.colors.white};
    font-size: 24px;
    transition: transform 0.3s ease;
    transform: ${(props) =>
      props.$isMinimized ? 'rotate(0deg)' : 'rotate(180deg)'};
  }
`

export const ContentDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`

export const ContentDescriptionTitle = styled.div`
  color: ${(props) => props.theme.colors.white};
  font-size: 24px;
  font-weight: 700;
`

export const ContentDescriptionText = styled.div`
  color: ${(props) => props.theme.colors.white};
  font-size: 16px;
  font-weight: 400;
  align-self: stretch;
`

export const ContentDescriptionTextLink = styled.a`
  color: ${(props) => props.theme.colors.red};
  margin-right: 4px;
`

export const StyledLoading = styled.div`
  width: 100%;
`

export const StyledSkeleton = styled(Skeleton)`
  && {
    border-radius: 4px;
    background: ${(props) => props.theme.colors.grayLight};
  }
`

export const ContentHome = styled.div<StyledContentProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 50px 0 50px 30px;
  height: ${(props) =>
    props.$hideHeader ? 'calc(100vh - 140px)' : 'calc(100vh - 240px)'};
  transition: height 0.3s ease;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.graySemiDark};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.gray};
    border-radius: 10px;
    border: 2px solid ${(props) => props.theme.colors.graySemiDark};
  }

  scrollbar-width: thin;
  scrollbar-color: ${(props) => props.theme.colors.gray}
    ${(props) => props.theme.colors.graySemiDark};

  @media (max-width: 1250px) {
    padding: 24px 0 42px 0;
    height: ${(props) =>
      props.$hideHeader ? 'calc(100vh - 106px)' : 'calc(100vh - 224px)'};
  }

  @media (max-width: 900px) {
    padding: 24px 0px;
    height: 100%;
  }
`

export const ContentTitleHome = styled.span`
  text-align: center;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  width: 100%;
  color: ${(props) => props.theme.colors.white};
`

export const ContentDescriptionHome = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
  text-align: center;
`

export const ContentDescriptionTitleHome = styled.div`
  color: ${(props) => props.theme.colors.white};
  font-size: 24px;
  font-weight: 700;
  line-height: 40px;
`

export const ContentDescriptionTextHome = styled.div`
  color: ${(props) => props.theme.colors.white};
  font-size: 18px;
  font-weight: 400;
  align-self: stretch;
  padding: 0 10px;
`

export const ContentDescriptionBoxGroupHome = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;

  @media (max-width: 950px) {
    flex-direction: column;
    width: calc(100% - 32px);
    margin: 0 auto;
  }
`

export const ContentDescriptionBoxHome = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 16px;
  background-color: ${(props) => props.theme.colors.grayLight};
  border-radius: 8px;
`

export const ContentDescriptionBoxTitleHome = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  color: ${(props) => props.theme.colors.white};
  font-weight: 700;
  line-height: 32px;
  gap: 10px;
  font-size: 24px;

  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid ${(props) => props.theme.colors.white};

  svg {
    font-size: 32px;
  }
`

export const ContentDescriptionBoxTextHome = styled.div`
  color: ${(props) => props.theme.colors.white};
  font-size: 18px;
  font-weight: 400;
  align-self: stretch;
  line-height: normal;
`

export const ContentDescriptionBoxSecurityHome = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  background-color: ${(props) => props.theme.colors.bordeaux};
  border-radius: 8px;
`

export const ContentDescriptionBoxSecurityTitleHome = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  color: ${(props) => props.theme.colors.white};
  font-weight: 700;
  line-height: 32px;
  gap: 10px;
  font-size: 24px;

  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid ${(props) => props.theme.colors.white};

  svg {
    font-size: 32px;
  }
`

export const ContentDescriptionBoxSecurityTextHome = styled.div`
  color: ${(props) => props.theme.colors.white};
  font-size: 18px;
  font-weight: 400;
  align-self: stretch;
  line-height: normal;
`
